import { reducer as marketingReducer } from './marketing.slice';

export default marketingReducer;
